/* Ring builder — configurator + live price + SVG preview. Add-to-cart posts the
   build to the bridge App Proxy, which creates a Draft Order at the
   server-recomputed price and returns a checkout URL. Vanilla, scoped to .rb. */
(function () {
  var root = document.querySelector('[data-rb]');
  if (!root) return;

  var PROXY = (root.getAttribute('data-proxy') || '/apps/diamonds').replace(/\/$/, '');
  var BASE = parseInt(root.getAttribute('data-base'), 10) || 0;
  var PRODUCT_ID = root.getAttribute('data-product-id');

  var els = {
    priceNow: root.querySelector('[data-price-now]'),
    priceMonth: root.querySelector('[data-price-month]'),
    ctaPrice: root.querySelector('[data-cta-price]'),
    sMetal: root.querySelector('[data-s-metal]'),
    sShape: root.querySelector('[data-s-shape]'),
    sQual: root.querySelector('[data-s-qual]'),
    sCarat: root.querySelector('[data-s-carat]'),
    stageTag: root.querySelector('[data-stage-tag]'),
    svg: root.querySelector('[data-ring-svg]'),
    stone: root.querySelector('[data-stone]'),
    size: root.querySelector('[data-size]'),
    engraveText: root.querySelector('[data-engrave-text]'),
    addBtn: root.querySelector('[data-add]'),
    err: root.querySelector('[data-err]')
  };

  var METAL_STROKE = { pt: '#7E7E82', wg: '#8A8A8E', yg: '#B8923A', rg: '#B27A66' };

  function fmt(n) { return Math.round(n).toLocaleString('sv-SE').replace(/,/g, ' ') + ' kr'; }

  function getOn(g) {
    return root.querySelector('.rb-opts[data-group="' + g + '"] .rb-o.rb-on, .rb-toggle2[data-group="' + g + '"] .rb-o.rb-on');
  }

  function stonePaths(shape) {
    var x = 110, y = 66;
    switch (shape) {
      case 'oval': return '<ellipse cx="' + x + '" cy="' + y + '" rx="24" ry="36"/><path d="M110 30 L110 102 M86 66 L134 66 M92 44 L128 88 M128 44 L92 88"/>';
      case 'emerald': return '<rect x="84" y="32" width="52" height="68" rx="5"/><rect x="92" y="40" width="36" height="52" rx="3"/><path d="M84 48 L136 48 M84 84 L136 84"/>';
      case 'radiant': return '<rect x="80" y="34" width="60" height="62" rx="6"/><path d="M110 34 L110 96 M80 65 L140 65 M88 42 L132 88 M132 42 L88 88"/>';
      case 'cushion': return '<rect x="80" y="36" width="60" height="60" rx="18"/><path d="M110 36 L110 96 M80 66 L140 66 M90 46 L130 86 M130 46 L90 86"/>';
      case 'pear': return '<path d="M110 30 C90 50 84 72 110 102 C136 72 130 50 110 30 Z"/><path d="M110 36 L110 96 M88 70 L132 70 M96 50 L124 88 M124 50 L96 88"/>';
      default: return '<circle cx="' + x + '" cy="' + y + '" r="34"/><ellipse cx="' + x + '" cy="' + y + '" rx="34" ry="13"/><path d="M110 32 L110 100 M76 66 L144 66 M86 42 L134 90 M134 42 L86 90 M84 66 L110 100 L136 66"/>';
    }
  }

  function caratScale(name) {
    var m = { '0.50ct': 0.72, '0.70ct': 0.82, '1.00ct': 1, '1.25ct': 1.1, '1.50ct': 1.2, '2.00ct': 1.35 };
    return m[name] || 1;
  }

  function renderPreview() {
    var metalEl = getOn('metal'), shapeEl = getOn('shape'), caratEl = getOn('carat');
    var metalKey = metalEl ? metalEl.getAttribute('data-metal') : 'wg';
    var shape = shapeEl ? shapeEl.getAttribute('data-shape') : 'round';
    if (els.svg) els.svg.setAttribute('stroke', METAL_STROKE[metalKey] || '#4A1721');
    var scale = caratScale(caratEl ? caratEl.getAttribute('data-name') : '1.00ct');
    if (els.stone) els.stone.innerHTML = '<g transform="translate(110 66) scale(' + scale + ') translate(-110 -66)">' + stonePaths(shape) + '</g>';
  }

  function total() {
    var t = BASE;
    root.querySelectorAll('.rb-opts .rb-o.rb-on, .rb-toggle2 .rb-o.rb-on').forEach(function (o) {
      t += parseInt(o.getAttribute('data-delta') || '0', 10);
    });
    return t;
  }

  function recalc() {
    var t = total();
    var s = fmt(t);
    if (els.priceNow) els.priceNow.textContent = s;
    if (els.ctaPrice) els.ctaPrice.textContent = s;
    if (els.priceMonth) els.priceMonth.textContent = Math.round(t / 12).toLocaleString('sv-SE').replace(/,/g, ' ');
  }

  function name(g) { var el = getOn(g); return el ? el.getAttribute('data-name') : ''; }

  function refreshSummary() {
    if (els.sMetal) els.sMetal.textContent = name('metal');
    if (els.sShape) els.sShape.textContent = name('shape');
    if (els.sQual) els.sQual.textContent = name('qual');
    if (els.sCarat) els.sCarat.textContent = name('carat');
    var metalEl = getOn('metal');
    var tag = metalEl ? (metalEl.getAttribute('data-tag') || '18k white gold') : '18k white gold';
    if (els.stageTag) els.stageTag.textContent = tag + ' · ' + name('shape').toLowerCase() + ' · ' + name('carat');
  }

  function syncEngrave() {
    var on = getOn('engrave');
    var show = on && on.getAttribute('data-name') === 'Engraved';
    if (els.engraveText) els.engraveText.hidden = !show;
  }

  // option selection (delegated, scoped)
  root.querySelectorAll('.rb-opts, .rb-toggle2').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var o = e.target.closest('.rb-o');
      if (!o || !group.contains(o)) return;
      group.querySelectorAll('.rb-o').forEach(function (x) { x.classList.remove('rb-on'); });
      o.classList.add('rb-on');
      recalc(); refreshSummary(); renderPreview(); syncEngrave();
    });
  });

  // preview view tabs (visual only for now)
  root.querySelectorAll('.rb-view').forEach(function (v) {
    v.addEventListener('click', function () {
      root.querySelectorAll('.rb-view').forEach(function (x) { x.classList.remove('rb-on'); });
      v.classList.add('rb-on');
    });
  });

  // add to cart → bridge draft order → checkout
  function build() {
    var sel = {};
    ['metal', 'shape', 'qual', 'carat', 'engrave'].forEach(function (g) {
      var el = getOn(g);
      if (el) sel[g] = { name: el.getAttribute('data-name'), delta: parseInt(el.getAttribute('data-delta') || '0', 10) };
    });
    return {
      productId: PRODUCT_ID,
      size: els.size ? els.size.value : '',
      engraveText: (els.engraveText && !els.engraveText.hidden) ? els.engraveText.value : '',
      selections: sel
    };
  }

  if (els.addBtn) {
    els.addBtn.addEventListener('click', function () {
      if (els.err) { els.err.hidden = true; els.err.textContent = ''; }
      if (!els.size || !els.size.value) {
        if (els.err) { els.err.textContent = 'Please choose a ring size first.'; els.err.hidden = false; }
        return;
      }
      els.addBtn.disabled = true;
      var label = els.addBtn.querySelector('[data-cta-price]') ? els.addBtn.innerHTML : null;
      els.addBtn.textContent = 'Building…';
      fetch(PROXY + '/ring/checkout', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(build())
      })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (data) {
          if (data && data.checkoutUrl) { window.location.href = data.checkoutUrl; return; }
          throw new Error('no checkout url');
        })
        .catch(function () {
          if (els.err) { els.err.textContent = 'Something went wrong building your ring. Please try again or contact us.'; els.err.hidden = false; }
          els.addBtn.disabled = false;
          if (label) els.addBtn.innerHTML = label; else recalc();
        });
    });
  }

  recalc(); refreshSummary(); renderPreview(); syncEngrave();
})();
